module.exports = __webpack_public_path__ + "media/horse-whinny-bad.d570d8ab.mp3";